/**
 * Report event from the agent.
 *
 * {@link https://github.com/dotse/bredbandskollen/wiki/Bredbandskollen-API-v2#report-result}
 * {@link https://github.com/dotse/bredbandskollen/wiki/Agent-API-v2#the-report-event}
 */
export default function onMeasurementInfo(m, measurementInfo) {
	m.setData({
		measurementInfo: {
			...m.data.measurementInfo,
			...measurementInfo,
		},
		operatorInfoMessage:
			measurementInfo.operatorInfoMessage || m.data.operatorInfoMessage,
		operatorBadInfoMessage:
			measurementInfo.operatorBadInfoMessage ||
			m.data.operatorBadInfoMessage,
	});
}
